<template>
	<div class="content-pad-vert">
		<v-btn class="info" @click="requestPermission">Request Permission</v-btn>
		<v-btn class="success" @click="subscribeUser">Subscribe</v-btn>
		<v-btn class="error" @click="unsubscribeUser">Unsubscribe</v-btn>
	</div>
</template>

<script>
import axios from 'axios'
import {mapGetters, mapActions} from 'vuex'
export default {
	name: 'testpush',
	data() {
		return {

		}
	},
	methods: {
		...mapActions(['subscribeUserToPush', 'unsubscribeUserFromPush']),
		requestPermission () {
			if ('Notification' in window && navigator.serviceWorker) {
				Notification.requestPermission(function(status) {
					console.log('Notification permission status:', status);
				});
			}
		},
		subscribeUser () {
			this.subscribeUserToPush()
		},
		unsubscribeUser () {
			this.unsubscribeUserFromPush()
		}
	},
	computed: {
		...mapGetters([
			'user'
		])
	}
}

</script>